import { AssetSamsaraVehicleFeature } from '../features/asset-samsara-vehicle/asset-samsara-vehicle.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class AssetsSamsaraVehicleLayerRenderer extends StandardLayerRenderer {
  protected Feature = AssetSamsaraVehicleFeature;
}
